import { render } from "./FooterRikolto.vue?vue&type=template&id=1baec2df&scoped=true"
import script from "./FooterRikolto.vue?vue&type=script&lang=js"
export * from "./FooterRikolto.vue?vue&type=script&lang=js"

import "./FooterRikolto.vue?vue&type=style&index=0&id=1baec2df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1baec2df"]])

export default __exports__